<script setup>
import IOrderSubscribeItem from '@components/IOrderSubscribeItem/IOrderSubscribeItem.vue';
import IOrderEventItem from '@components/IOrderEventItem/IOrderEventItem.vue';

const props = defineProps({
  itemCase: {
    type: Object,
    required: true,
  },
  trashButton: {
    type: Boolean,
    default: true,
  },
  isHistory: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <IOrderSubscribeItem
    v-if="itemCase.type === 'sub'"
    :item-case="itemCase"
    :trash-button="trashButton"
  />
  <IOrderEventItem
    v-else :item-case="itemCase"
    :trash-button="trashButton"
    :is-history="isHistory"
  />
</template>

<style scoped lang="scss"></style>
